import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateSharedListPayload } from '@app-store/slices/sharedLists/create'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ICreateSharedListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.create

function* createSharedListSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/companies/shared-lists`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
            notification.success({
                message: 'Match list shared successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createSharedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createSharedListSagaTask)
}

export default createSharedListSaga
